// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosStatusBackfill_RecalculaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /cli/Compromissos_status_backfill/recalcula
 *
 * Chamado 2026-0038: `compromissos.compromisso_status_financeiro` só é
 * recalculada quando um recebimento é criado, alterado ou apagado — nada a
 * mantém em lote. Uma linha que ficou com 1 gravado e hoje tem zero recebido
 * continuava dizendo "Parcial". Este é o comando que cura o passado.
 *
 * default 'dry-run': um POST sem corpo NUNCA escreve. Aqui isso pesa mais que
 * de costume — o `apply` é um UPDATE na tabela inteira de compromissos.
 */
import { registerContract } from './validate'

export interface CompromissosStatusBackfill_RecalculaInput {
mode?: string
}

registerContract('CompromissosStatusBackfill_RecalculaInput', {
  mode: { type: 'string',  required: false },
})
